import React from 'react';
import { FaTimes, FaUserClock, FaVideo, FaUserPlus } from 'react-icons/fa';
import './PendingCandidatesModal.css';
import config from '../../../config';

const PendingCandidatesModal = ({ 
  show, 
  onClose, 
  candidates, 
  onStartInterview,
  loading 
}) => {
  if (!show) return null;

  return (
    <div className="pending-modal-overlay" onClick={onClose}>
      <div className="pending-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="pending-modal-header">
          <div className="pending-modal-title">
            <FaUserClock className="pending-modal-icon" />
            <h3>Pending Candidates</h3>
          </div>
          <button className="pending-modal-close" onClick={onClose} type="button">
            <FaTimes />
          </button>
        </div>

        <div className="pending-modal-body">
          {loading ? (
            <div className="pending-loading">
              <div className="pending-spinner" />
              <p>Loading candidates...</p>
            </div>
          ) : candidates.length === 0 ? (
            <div className="pending-empty">
              <div className="pending-empty-icon">✅</div>
              <h4>No Pending Candidates</h4>
              <p>All candidates have been reviewed</p>
            </div>
          ) : (
            <>
              <div className="pending-candidates-list">
                {candidates.map((candidate) => (
                  <div key={candidate.id || candidate.candidate_id} className="pending-candidate-card">
                    <div className="pending-candidate-avatar">
                      {candidate.profile_image ? (
                        <img 
                          src={`${config.baseURL}/uploads/profiles/${candidate.profile_image }`} 
                          alt={`${candidate.first_name} ${candidate.last_name}`}
                        />
                      ) : (
                        <div className="pending-avatar-placeholder">
                          {candidate.first_name?.charAt(0) || '?'}
                        </div>
                      )}
                    </div>
                    
                    <div className="pending-candidate-info">
                      <span className="pending-candidate-name">
                        {candidate.first_name} {candidate.last_name}
                      </span>
                      <span className="pending-candidate-detail">
                        {candidate.email}
                      </span>
                      {candidate.profession && (
                        <span className="pending-candidate-profession">
                          {candidate.profession}
                        </span>
                      )}
                      {candidate.profileId && (
                        <span className="pending-candidate-id">
                          ID: {candidate.profileId}
                        </span>
                      )}
                    </div>

                    <div className="pending-candidate-actions">
                      <button
                        className="pending-start-btn"
                        onClick={() => onStartInterview(candidate)}
                        title="Start interview with this candidate"
                      >
                        <FaVideo />
                        <span>Start Interview</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingCandidatesModal;